import "./polyfills";
import App from "./App";
import "./index.css";
import { StrictMode } from "react";
import { render } from "react-dom";
import * as Sentry from "@sentry/react";
import { initTelegram } from "./telegram";

Sentry.init({
  dsn: "https://420644e7cdb4f44e791df5e276bd72ee@o306298.ingest.us.sentry.io/4507888620601344",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Distributed tracing headers are only attached to our own backend.
  tracePropagationTargets: ["localhost", /^https:\/\/api\.agorata\.io/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Signal readiness + expand to full height as early as possible.
initTelegram();

render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root") as HTMLElement
);
